import { render, staticRenderFns } from "./icon-btn.vue?vue&type=template&id=a2d17da8&scoped=true"
import script from "./icon-btn.vue?vue&type=script&lang=ts"
export * from "./icon-btn.vue?vue&type=script&lang=ts"
import style0 from "./icon-btn.vue?vue&type=style&index=0&id=a2d17da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d17da8",
  null
  
)

export default component.exports